import React from 'react';
import cx from 'classnames';
import Proptypes from 'prop-types';

import { PARAGRAPH_DEFINITIONS } from '@xingternal/content-editor-plugin-helpers';

import { PARAGRAPH_TAG_NAME } from './constants';
import styles from './Paragraph.css';

const renderer = ({
  node: { type },
  PARAGRAPH_TAG = PARAGRAPH_TAG_NAME,
  ...attributes
}) => {
  if (type === PARAGRAPH_DEFINITIONS.type) {
    const {
      nodeAttributes: { children },
      renderers,
      className,
      ...restOfAttributes
    } = attributes;

    return (
      <PARAGRAPH_TAG
        {...restOfAttributes}
        className={cx(styles.paragraph, className)}
      >
        {children}
      </PARAGRAPH_TAG>
    );
  }
};

renderer.Proptypes = {
  node: Proptypes.object,
  attributes: Proptypes.object,
};

export { renderer };
